import { createColumnHelper } from '@tanstack/react-table';

import { RoleBinding } from '../types';

export const columnHelper = createColumnHelper<RoleBinding>();
